// Mock data para Bezalel Technology Landing Page

export const heroData = {
  title: "BEZALEL TECHNOLOGY",
  subtitle: "Innovación Tecnológica para tu Éxito Digital",
  description: "Infraestructura, Desarrollo y Seguridad potenciados con IA. Todo lo que tu empresa necesita en un solo lugar.",
  ctaText: "¡Contáctanos Hoy!",
  ctaLink: "#contacto",
  backgroundImage: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg"
};

export const aboutData = {
  title: "Sobre Nosotros",
  description: "En BEZALEL TECHNOLOGY, somos tu aliado estratégico en el mundo digital. Ofrecemos soluciones tecnológicas de vanguardia, diseñadas para optimizar tus operaciones y potenciar tu presencia online. Con un equipo de expertos y un enfoque centrado en la innovación, garantizamos resultados que superan tus expectativas.",
  stats: [
    { number: "7+", label: "Años de Experiencia" },
    { number: "10+", label: "Proyectos Exitosos" },
    { number: "100%", label: "Clientes Satisfechos" },
    { number: "24/7", label: "Soporte Técnico" }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Desarrollo de Páginas Web",
    description: "Creamos sitios web modernos, responsive y optimizados para SEO, que reflejan la identidad de tu marca y atraen a tu público objetivo.",
    icon: "Code",
    image: "https://images.pexels.com/photos/16129724/pexels-photo-16129724.jpeg",
    features: ["Diseño Responsive", "Optimización SEO", "Alta Performance"]
  },
  {
    id: 2,
    title: "Despliegue de Aplicaciones Web",
    description: "Aseguramos que tus aplicaciones web estén disponibles y funcionen sin interrupciones con servicios de despliegue eficientes y escalables.",
    icon: "Cloud",
    image: "https://images.unsplash.com/photo-1690627931320-16ac56eb2588",
    features: ["Alta Disponibilidad", "Escalabilidad", "Monitoreo 24/7"]
  },
  {
    id: 3,
    title: "Venta de Licencias",
    description: "Proporcionamos licencias de software originales y actualizadas para todas tus necesidades empresariales, garantizando legalidad y soporte.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1669023414162-5bb06bbff0ec",
    features: ["Software Original", "Soporte Incluido", "Actualizaciones"]
  },
  {
    id: 4,
    title: "Registro de Marca",
    description: "Protege tu identidad empresarial. Te asesoramos y gestionamos el registro de tu marca, asegurando protección legal contra uso no autorizado.",
    icon: "Award",
    image: "https://images.unsplash.com/photo-1642069525937-ce9e8b24413a",
    features: ["Asesoría Legal", "Gestión Completa", "Protección Total"]
  },
  {
    id: 5,
    title: "Venta de Hardware",
    description: "Ofrecemos una amplia gama de equipos informáticos de última generación. Soluciones de hardware robustas y fiables para tu infraestructura.",
    icon: "Server",
    image: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg",
    features: ["Equipos de Vanguardia", "Garantía Extendida", "Instalación"]
  },
  {
    id: 6,
    title: "Seguridad Informática",
    description: "Protegemos tus datos y sistemas contra amenazas cibernéticas con soluciones avanzadas de ciberseguridad y auditorías de seguridad.",
    icon: "ShieldCheck",
    image: "https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg",
    features: ["Auditorías", "Protección Avanzada", "Respuesta a Incidentes"]
  },
  {
    id: 7,
    title: "Seguridad de Redes de Datos",
    description: "Diseñamos e implementamos redes seguras que garantizan la confidencialidad, integridad y disponibilidad de tu información.",
    icon: "Network",
    image: "https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg",
    features: ["Redes Seguras", "Monitoreo Continuo", "Redundancia"]
  },
  {
    id: 8,
    title: "VPS Cloud",
    description: "Servidores privados virtuales en la nube que ofrecen flexibilidad, escalabilidad y alto rendimiento en un entorno seguro y personalizable.",
    icon: "CloudCog",
    image: "https://images.unsplash.com/photo-1548544027-1a96c4c24c7a",
    features: ["Alta Performance", "Personalizable", "Backup Automático"]
  },
  {
    id: 9,
    title: "Implementación Automatización con IA",
    description: "Transformamos tus procesos empresariales con soluciones de inteligencia artificial y automatización inteligente para maximizar la eficiencia.",
    icon: "BrainCircuit",
    image: "https://images.pexels.com/photos/1036642/pexels-photo-1036642.jpeg",
    features: ["IA Avanzada", "Automatización", "Optimización"]
  }
];

export const teamData = [
  {
    id: 1,
    name: "Jose Rodriguez",
    role: "CEO & Fundador",
    description: "SRE con más de 7 años de experiencia en tecnología empresarial y transformación digital.",
    image: "https://bezalel.com.co/img/team/jose.png",
    linkedin: "https://www.linkedin.com/in/joseluis-rodriguez-martinez/",
    github: "https://github.com/H0x3"
  },
  {
    id: 2,
    name: "Carolina Linares",
    role: "CEO & Directora de Desarrollo",
    description: "Especialista en arquitectura de software y metodologías ágiles, con expertise en tecnologías web modernas.",
    image: "https://bezalel.com.co/img/team/carolina.png",
    linkedin: "https://www.linkedin.com/in/carolinarestechnology/",
    github: "#"
  },
  {
    id: 3,
    name: "Juan Solarte",
    role: "Especialista FullStack",
    description: "Experto en desarrollo de aplicaciones web y móviles, con experiencia en las principales tecnologías de la industria.",
    image: "https://bezalel.com.co/img/team/juan.png",
    linkedin: "#",
    github: "#"
  }
];

export const contactData = {
  email: "servicios@bezalel.com.co",
  phone: "+57 3162496551",
  whatsapp: "+573239458911",
  address: "Calle del Coco #41-53B69, Arjona, Colombia",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3923.456!2d-75.35!3d10.25!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTDCsDE1JzAwLjAiTiA3NcKwMjEnMDAuMCJX!5e0!3m2!1sen!2sco!4v1234567890"
};

export const techStackData = [
  {
    id: 1,
    title: "Tecnología de Vanguardia",
    description: "Implementamos las últimas tecnologías para mantener tu negocio a la vanguardia del mercado digital.",
    image: "https://images.pexels.com/photos/158826/structure-light-led-movement-158826.jpeg"
  },
  {
    id: 2,
    title: "Desarrollo Innovador",
    description: "Creamos soluciones de software personalizadas que se adaptan perfectamente a las necesidades de tu empresa.",
    image: "https://images.pexels.com/photos/16129728/pexels-photo-16129728.jpeg"
  },
  {
    id: 3,
    title: "Metodologías Ágiles",
    description: "Utilizamos metodologías ágiles para garantizar entregas rápidas y de alta calidad en todos nuestros proyectos.",
    image: "https://images.pexels.com/photos/3653997/pexels-photo-3653997.jpeg"
  },
  {
    id: 4,
    title: "Proyectos Exitosos",
    description: "Nuestro historial de proyectos exitosos respalda nuestra experiencia y compromiso con la excelencia.",
    image: "https://images.pexels.com/photos/35425762/pexels-photo-35425762.jpeg"
  }
];
